// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";

function x(param) {
  return param[0];
}

function y(param) {
  return param[1];
}

function fill(v) {
  return [
    v,
    v
  ];
}

function map(param, f) {
  return [
    f(param[0]),
    f(param[1])
  ];
}

function reduce(param, init, f) {
  return Stdlib_Array.reduce([
    param[0],
    param[1]
  ], init, f);
}

function zipWith(f, param, param$1) {
  return [
    f(param[0], param$1[0]),
    f(param[1], param$1[1])
  ];
}

function jsonCodec(elementCodec) {
  let arrayCodec = Jzon.array(elementCodec);
  return Jzon.custom(param => Jzon.encodeWith([
    param[0],
    param[1]
  ], arrayCodec), json => {
    let match = Jzon.decodeWith(json, arrayCodec);
    if (match.TAG === "Ok") {
      let match$1 = match._0;
      if (match$1.length === 2) {
        let a = match$1[0];
        let b = match$1[1];
        return {
          TAG: "Ok",
          _0: [
            a,
            b
          ]
        };
      }
    }
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "array[2]",
          json
        ]
      }
    };
  });
}

export {
  x,
  y,
  fill,
  map,
  reduce,
  zipWith,
  jsonCodec,
}
/* No side effect */
